export default class ProfileViewModel {
    public id: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
    public phoneNumber: string = '';
    public userType: string = '';
    public client: string | null = null;
    public signature: string = '';
}